<template>
    <div class="animated fadeIn">
        <component-header
            title="Access Rule"
            :isLoading="loading"
            :hasSearch="false"
            :hasReload="true"
            @reload-data="accessRule"
            :hasRadio="false"
            :hasCreate="true"
            :hasback="false"
            @create-press="$router.push({ path: '/setup/accessrule/create' })"
            createButtonText="Create Access Rule"
        />
        <b-row>
            <b-col cols="12" md="12">
                <b-card>
                    <b-table
                        class="table-radius mt-3"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :current-page="currentPage"
                        :per-page="10"
                        :items="accessrulesList"
                        thead-class="header"
                        :fields="Columns"
                        show-empty
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    @view="openAccessRuleModal(data.index)"
                                    @edit="goToEditAccessRule(data.item)"
                                />
                                <b-modal
                                    :id="`modal-${data.index}`"
                                    size="md"
                                    centered
                                    hide-footer
                                    :ref="`modal-${data.index}`"
                                    title="View Access Rules"
                                     modal-class="center-title-modal"
                                >
                                    <b-row class="mx-1 my-2">
                                        <label for="planName">Name</label>
                                        <b-form-input
                                            class="w-100"
                                            id="planName"
                                            disabled
                                            inputType="text"
                                            v-model="data.item.Name"
                                        />
                                    </b-row>
                                    <b-row class="mx-1 my-2">
                                        <label for="keys">keys</label>
                                        <b-form-input
                                            id="keys"
                                            disabled
                                            class="w-100"
                                            inputType="text"
                                            v-model="data.item.Keys"
                                        />
                                    </b-row>
                                     <div class="text-center mt-3 mb-3">
                                        <b-button
                                          variant="secondary"
                                          size="sm"
                                          @click="$refs[`modal-${data.index}`].hide()"
                                        >
                                          Cancel
                                        </b-button>
                                    </div>
                                </b-modal>
                            </div>
                        </template>
                        <template v-slot:empty="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                    </b-table>
                    <div class="pagination-wrapper" v-if="accessrulesList.length > 0">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="10"
                            :total-rows="accessrulesList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import componentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";

export default {
    name: "access-rule",
    components: {
        componentHeader,
        ActionButtonGroup,
    },
    data() {
        return {
            loading: false,
            perPage: 30,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            sortBy: "createdAt",
            sortDesc: true,
            Columns: [
                {
                    key: "Name",
                    sortable: true,
                },
                {
                    key: "Keys",
                },
                {
                    key: "action",
                },
            ],
            _cachedAccessRulesList: null,
            _cachedDataHash: null,
        };
    },
    computed: {
        rawAccessRuleData() {
            return this.$store.getters["accessrule/GetAccessRuleList"];
        },
        accessrulesList() {
            const data = this.rawAccessRuleData;
            
            // Early return for empty or invalid data
            if (!Array.isArray(data) || data.length === 0) {
                this._cachedAccessRulesList = [];
                this._cachedDataHash = null;
                return [];
            }

            const dataHash = data.map(d => d?._id).join(',') + `|${data.length}`;
            if (this._cachedDataHash === dataHash && this._cachedAccessRulesList) {
                return this._cachedAccessRulesList;
            }

            // Transform data only when it actually changes
            this._cachedAccessRulesList = data.map((d) => ({
                Name: d?.name ? d.name.toUpperCase() : '',
                Keys: d?.keys || '',
                itemId: d?._id || '',
            }));
            
            this._cachedDataHash = dataHash;
            return this._cachedAccessRulesList;
        },
    },
    methods: {
        async accessRule() {
            this.loading = true;
            await this.$store
                .dispatch("accessrule/accessRuleList")
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                    }
                });
            this.loading = false;
        },
        openAccessRuleModal(index) {
            this.$root.$emit("bv::show::modal", `modal-${index}`);
        },
        goToEditAccessRule(item) {
            this.$router.push({
                name: "access rule edit",
                params: {
                    id: item.itemId,
                    data: item,
                },
            });
        },
    },
    async mounted() {
        await this.accessRule();
    },
};
</script>
<style scoped>
:deep(.close) {
    color: black;
}

.table-radius {
    border-radius: 12px;
}

.btn-edit-accessrule {
    background: #fe7b08;
    border-color: #fe7b08;
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 1rem;
}

.pagination-wrapper :deep(.pagination) {
    display: inline-flex;
    flex-wrap: nowrap;
    margin-bottom: 0;
    justify-content: flex-end;
}

.pagination-wrapper :deep(.page-item) {
    display: inline-block;
    white-space: nowrap;
}

.pagination-wrapper :deep(.page-link) {
    display: inline-block;
}

.inline_btnTable {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
}

.inline_btnTable .button-circle {
    flex-shrink: 0;
}

/* Ensure buttons stay inline on small and mobile screens */
@media (max-width: 768px) {
    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 6px;
    }

    .inline_btnTable .button-circle {
        min-width: auto;
        padding: 0.25rem 0.5rem;
    }
}

@media (max-width: 576px) {
    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
        gap: 4px;
    }
    
    .inline_btnTable .button-circle {
        padding: 0.2rem 0.4rem;
        font-size: 0.875rem;
    }
    
    .inline_btnTable .mr-2 {
        margin-right: 0.25rem !important;
    }
    
    .pagination-wrapper {
        justify-content: flex-end;
        overflow-x: auto;
    }
    
    .pagination-wrapper :deep(.pagination) {
        flex-wrap: nowrap;
        min-width: fit-content;
    }
}
</style>
